import React, {Component} from "react";
import { connect } from 'react-redux';
import { packEntrepreneur, packEntrepreneurAddUpsell } from "../../../redux/actions/checkout_operations";
import lpevents from "../../../tracking/lpevents";

class _PackEntrepreneurFooterAB extends Component {
  
  componentDidMount(){
    lpevents.trackDatalayerMixpanel("Choisir ce pack", "lp_ab_dedicatedupsellscreenme")
    this.props.addUpsellPackEntrepreneur([]);
  }

  getPack = (chosenPack) => {
    let pack;
    switch (chosenPack) {
      case 0: pack= 'first_price';
              break;
      case 1: pack= 'second_price';
              break;    
      default: pack= 'third_price';
               break; 
    }
    return pack
  }
 
  goToNextStep = () => {
    const { selectPack, index } = this.props
    this.props.entrepreneurPack(false);
    this.props.addUpsellPackEntrepreneur([]);
    selectPack(index)
  }

  goToNextStepWithUpsell = () => {
    const { selectPack, index, detailsCheckout } = this.props
    this.props.entrepreneurPack(false)
    const chosenPack = this.getPack(index)
    const upsellArray = chosenPack && detailsCheckout[chosenPack] && detailsCheckout[chosenPack].upsell
    let upsell = upsellArray && upsellArray.length && [...Array(upsellArray.length)].map(() => false)
    // Only put the first upsell to true : to do the generic case after!!!
    if (upsell && upsell.length)
    upsell[0] = true

    this.props.addUpsellPackEntrepreneur(upsell)
    selectPack(index)
  }
  
  render(){
    const {footer} = this.props
    return(
      <div className="footer">
      <div className="priceWrapper">
        <p className="crossedOutPrice">{footer.oldPrice},<sup>00</sup>€</p>
        <p className="newPrice">{footer.newPrice},00€</p>
      </div>
      <button type="button" className="addBtn" onClick={this.goToNextStepWithUpsell}>{footer.btnText}</button>
      <button type="button" className="skipBtn"  onClick={this.goToNextStep}>{footer.skipBtnText}</button>
      <p className="footerText">{footer.footerText}</p>
    </div>
    )
  }
}

const mapStateToProps = state => ({
  detailsCheckout : state.checkout_operations.detailsCheckout,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  entrepreneurPack: (val) => {
    dispatch(packEntrepreneur(val));
  },

  addUpsellPackEntrepreneur: (val) => {
    dispatch(packEntrepreneurAddUpsell(val));
  },

});


const PackEntrepreneurFooterAB = connect(mapStateToProps, mapDispatchToProps)(_PackEntrepreneurFooterAB);

export default PackEntrepreneurFooterAB;


// WEBPACK FOOTER //
// ./src/components/buy/upsell/pack-entrepreneurAB-footer.js